import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepInventory extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Store Inventory: Resource Representations</h1>
				<h2 className="text--title l-margin-bottom">Inventory</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> inventory_id </td>
							<td> Integer </td>
							<td> The ID of the inventory </td>
							<td> </td>
						</tr>
						<tr>
							<td> item </td>
							<td> Object </td>
							<td> An object representation of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.no </td>
							<td> String</td>
							<td> Item's identification number in BrickLink catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.name </td>
							<td> String </td>
							<td> The name of this item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td> MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> item.category_id </td>
							<td> Integer </td>
							<td> The main category of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> The ID of the color of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_name </td>
							<td> String </td>
							<td> Color name of the item </td>
							<td>  </td>
						</tr>
						<tr>
							<td> quantity </td>
							<td> Integer </td>
							<td> The number of items included in this inventory </td>
							<td> </td>
						</tr>
						<tr>
							<td> new_or_used </td>
							<td> String</td>
							<td> Indicates whether the item is new or used </td>
							<td> N: New, U: Used </td>
						</tr>
						<tr>
							<td> completeness </td>
							<td> String </td>
							<td> Indicates whether the set is complete or incomplete <br/>(This value is valid only for SET type) </td>
							<td> C: Complete, B: Incomplete, S: Sealed </td>
						</tr>
						<tr>
							<td> unit_price </td>
							<td> Fixed Point Number </td>
							<td> The original price of this item per sale unit </td>
							<td> </td>
						</tr>
						<tr>
							<td> bind_id </td>
							<td> Integer </td>
							<td> The ID of the parent lot that this lot is bound to </td>
							<td> </td>
						</tr>
						<tr>
							<td> description </td>
							<td> String </td>
							<td> A short description for this inventory </td>
							<td> </td>
						</tr>
						<tr>
							<td> remarks </td>
							<td> String </td>
							<td> User remarks on this inventory </td>
							<td> </td>
						</tr>
						<tr>
							<td> bulk </td>
							<td> Integer </td>
							<td> Buyers can buy this item only in multiples of the bulk amount</td>
							<td> </td>
						</tr>
						<tr>
							<td> is_retain </td>
							<td> Boolean </td>
							<td>Indicates whether the item retains in inventory after it is sold out </td>
							<td> </td>
						</tr>
						<tr>
							<td> is_stock_room </td>
							<td> Boolean </td>
							<td>Indicates whether the item appears only in owner’s inventory </td>
							<td> </td>
						</tr>
						<tr>
							<td> stock_room_id </td>
							<td> String </td>
							<td> Indicates the stockroom that the item to be placed when the user uses multiple stockroom</td>
							<td> A, B, C </td>
						</tr>
						<tr>
							<td> date_created </td>
							<td> Timestamp </td>
							<td>The time this lot is created </td>
							<td></td>
						</tr>
						<tr>
							<td> my_cost </td>
							<td> Fixed Point Number </td>
							<td><a href="http://www.bricklink.com/help.asp?helpID=1109" target="_blank">My Cost</a> value to tracking the cost of item </td>
							<td> </td>
						</tr>
						<tr>
							<td> sale_rate </td>
							<td> Integer </td>
							<td><a href="http://www.bricklink.com/help.asp?helpID=46" target="_blank">Sale</a> value to adjust item price</td>
							<td>Must be less than 100. 20 for 20% sale </td>
						</tr>
						<tr>
							<td> tier_quantity1 </td>
							<td> Integer</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a> </td>
							<td> 0 for no tier sale option </td>
						</tr>
						<tr>
							<td> tier_quantity2 </td>
							<td> Integer</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a></td>
							<td> 0 for no tier sale option, Must be greater than tier_quantity1 </td>
						</tr>
						<tr>
							<td> tier_quantity3 </td>
							<td> Integer</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a> </td>
							<td> 0 for no tier sale option, Must be greater than tier_quantity2 </td>
						</tr>
						<tr>
							<td> tier_price1 </td>
							<td> Fixed Point Number</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a></td>
							<td> 0 for no tier sale option. Must be less than unit_price </td>
						</tr>
						<tr>
							<td> tier_price2 </td>
							<td> Fixed Point Number</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a></td>
							<td> 0 for no tier sale option, Must be less than tier_price1 </td>
						</tr>
						<tr>
							<td> tier_price3 </td>
							<td> Fixed Point Number</td>
							<td>A parameter for <a href="http://www.bricklink.com/help.asp?helpID=131" target="_blank">Tiered pricing</a></td>
							<td> 0 for no tier sale option, Must be less than tier_price2 </td>
						</tr>
						<tr>
							<td> my_weight </td>
							<td> Fixed Point Number </td>
							<td> Custom weight of the item </td>
							<td> Upcoming </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "inventory_id":50592684,
    "item": {
        "no":"bel004",
        "name":"Belville Accessories - Complete Sprue - Perfume Bottles (same as 6932)",
        "type":"PART",
        "categoryID":48
    },
    "color_id":5,
    "quantity":12,
    "new_or_used":"U",
    "unit_price":"1.2000",
    "bind_id":0,
    "description":"",
    "remarks":"",
    "bulk":1,
    "is_retain":false,
    "is_stock_room":false,
    "date_created":"2013-12-18T05:00:00.000Z",
    "sale_rate":10,
    "my_cost":"1.0000",
    "tier_quantity1":10,
    "tier_price1":"1.0000",
    "tier_quantity2":20,
    "tier_price2":"0.8000",
    "tier_quantity3":0,
    "tier_price3":"0.0000" 
}`}</Highlight>
			</section>
		);
	}
}